import axios from 'axios';

var azure_security_key = process.env.REACT_APP_AZURE_FUNC_KEY;
const BASE_URL = process.env.REACT_APP_BASE_URL;

console.log('in axios.js',BASE_URL, azure_security_key);
export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: {
        'x-functions-key': azure_security_key,
        'Content-Type': 'application/json'
    },
    withCredentials: true
});
